import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import Button from '@mui/material/Button';
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { LocationsContext } from '../context/locations';
import { CreateSavedLocationsShape } from './create-saved-locations-shape';
import Loader from './loader';
import { LocationShapeItem } from './saved-locations-shapes-item';

interface SavedLocationsShapesProps {
  uid: number | null
}

export const SavedLocationsShapes = ({ uid }: SavedLocationsShapesProps) => {
  // const [title, setTitle] = useState('')
  // const [locationError, setLocationError] = useState<string[]>([]);
  // const [showMessage, setShowMessage] = useState(false)
  // const [notes, setNotes] = useState('')

  const [modalActive, setModalActive] = useState(false)

  const { 
    loading, 
    notSavedYetLocationShapes, 
    currentLocationShapes, 
    refetchLocationShapes 
  } = useContext(LocationsContext);

  // const key = useMemo(() => nanoid(), [])

  useEffect(() => {
    refetchLocationShapes(uid)
  }, [uid])

  const onUpdate = useCallback(() => {
    refetchLocationShapes(uid)
  }, [uid])
  
  // <div className={styles.column}>
  //             <p> {title}, {data.source}
  //               {lat && lon && <>, point: <strong>lat:</strong> {numeral(lat).format("0.00000")}, <strong>lon:</strong> {numeral(lon).format("0.00000")}</>}
  //             </p>
  //             <p>Created: {data.created_at && dayjs(data.created_at).format("DD/MM/YY")}</p>
  //           </div>

  // const columns = useMemo( () => {
  //   return [
  //     {
  //       field: 'title',
  //       headerName: 'Name',
  //       width: 300,
  //       editable: false,
  //     },
  //     {
  //       field: 'source',
  //       headerName: 'Source',
  //       width: 300,
  //       editable: false,
  //       // renderCell: (params: GridRenderCellParams<any, Date>) => {
  //       //   return (<>{data.source}</>)
  //       // },
  
  //     },
  //     {
  //       field: 'created_at',
  //       headerName: 'Created',
  //       width: 150,
  //       editable: false,
  //     }]
  // }, [])

  const useShapes = useMemo( () => {
    const temp = notSavedYetLocationShapes !== null ? [...notSavedYetLocationShapes] : []
    const saved = currentLocationShapes !== null ? [...currentLocationShapes] : []

    return [
      ...saved,
      ...temp,      
    ].sort( (a, b) => {
      const titleA = a.title || ''
      const titleB = b.title || ''
      return titleA.localeCompare(titleB)
    })
  }, [notSavedYetLocationShapes, currentLocationShapes])


  if (uid === null) return null

  return (
    <>
      <Button
        sx={{ maxWidth: '300px', ml: 'auto', mr: 'auto' }}
        type="submit"
        variant="text"
        // fullWidth={false}
        // color={`${deleteActive ? `warning` : `primary`}`}
        onClick={(e: React.SyntheticEvent) => {
          e.preventDefault()
          setModalActive(true)
        }}
        startIcon={<AddCircleOutlineIcon />}
      >Add shape or point</Button>
      {/* <DataGrid
        // className={styles.dataGrid}
        style={{ minHeight: 400, width: '100%' }}
        rows={useShapes}
        columns={columns}
        rowSelection={false}
        getRowId={(row) => row.uid || nanoid()}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 20,
            },
          },
        }}
        pageSizeOptions={[10, 20, 30]}
      /> */}
      {
        [...useShapes].map((shape) => {
          return (
            <LocationShapeItem key={`${shape?.uid}-${shape.created_at}`} data={shape} onUpdate={onUpdate} />
          )
        })
      }
      {loading.indexOf('location-shapes') !== -1 && <Loader />}
      {modalActive && 
        <CreateSavedLocationsShape onClose={() => {
          setModalActive(false)
          onUpdate()
        }} uid={uid} />
      }
      </>
  );
}